import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

const TicketDateComponent = (props) => {

    const [heightProgress, setHeightProgress] = useState(0);
    const color = props.isEnergo ? '#a2c13f' : '#c13fa3';
    const [isTop, setIsTop] = useState(true);

    useEffect(() => {
        window.onscroll = () => {
            const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrolled = (winScroll * 100) / height;
            setHeightProgress(scrolled);
            if (scrolled > 50) setIsTop(false);
            else setIsTop(true);
        }
    }, []);

   

    const scrollHandler = () => {
        if (isTop) {
            window.scrollTo(0, document.body.scrollHeight, {
                behavior: 'smooth'
            });
            setIsTop(false)
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            setIsTop(true);
        }
    }

    return (
        <div className="date-scroll-container" style={{ color: color }}>
            <div style={{ marginRight: "5px" }} id="dateBox" className="text-end">
                {props.date !== '' ? new Date(props.date).toLocaleString('DE-de', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', hour12: false, minute: '2-digit'}) : null}
            </div>
            <div className="text-end" style={{marginTop: "5px", marginRight: "5px"}}>
                <Button className={props.isEnergo ? 'btn-energo' : 'btn-energo-secondary'} onClick={() => scrollHandler()}>
                    {isTop? 
                        <FaArrowDown />
                    :
                        <FaArrowUp />
                    }
                </Button>
            </div>
            <div className="date-scroll-progress" style={{ height: heightProgress + "%", borderColor: color }}></div>
        </div>
    )
}

export default TicketDateComponent;